/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import searchModule, { StoreJx3SearchState } from './search';

export interface StoreJx3State {
  // modules
  search: StoreJx3SearchState;
}

export default {
  namespaced: true,
  modules: {
    search: searchModule,
  },
  state: {},
  actions: {},
  mutations: {},
};
